import { RECOMMENDATION_TIMESTAMP_REGEX } from './utils';

interface Props {
  text: string;
  onTimestampClick: (timestampText: string) => void;
  disabled?: boolean;
}

export function ClickableTimestamp({
  text,
  onTimestampClick,
  disabled = false,
}: Props) {
  const parts = [];
  let lastIndex = 0;
  let match;
  RECOMMENDATION_TIMESTAMP_REGEX.lastIndex = 0;

  while ((match = RECOMMENDATION_TIMESTAMP_REGEX.exec(text)) !== null) {
    const [fullMatch, hours, minutes, seconds] = match;
    const hour = parseInt(hours, 10);
    const minute = parseInt(minutes, 10);
    const second = parseInt(seconds, 10);

    if (
      hour >= 0 &&
      hour <= 23 &&
      minute >= 0 &&
      minute <= 59 &&
      second >= 0 &&
      second <= 59
    ) {
      if (match.index > lastIndex) {
        parts.push(text.slice(lastIndex, match.index));
      }
      parts.push(
        disabled ? (
          <span key={match.index} className="text-[13px] leading-relaxed">
            {fullMatch}
          </span>
        ) : (
          <button
            key={match.index}
            type="button"
            className="cursor-pointer border-none bg-transparent p-0 text-[13px] leading-relaxed underline hover:text-gray-800 dark:hover:text-gray-200"
            onClick={() => onTimestampClick(fullMatch)}
          >
            {fullMatch}
          </button>
        )
      );

      lastIndex = match.index + fullMatch.length;
    }
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return <span>{parts}</span>;
}

export default ClickableTimestamp;
